import Logout from './components/Logout';

import Home from './components/Content/Home/Home';

import Metadata from './components/Content/Metadata/Main';
import MetadataAdd from './components/Content/Metadata/Add';
import MetadataPreview from './components/Content/Metadata/Preview';


import Publication from './components/Content/Publication/Main';

import Keywords from './components/Content/Keywords/Main';
import KeywordsAdd from './components/Content/Keywords/Add';
import KeywordsEdit from './components/Content/Keywords/Edit';

import Users from './components/Content/Users/Main';
import UsersAdd from './components/Content/Users/Add';
import UsersEdit from './components/Content/Users/Edit';


import Activities from './components/Content/Activities/Main';

import {Switch, Route } from "react-router-dom";

export default function MenuRouting() {
    return (
        <Switch>
            <Route exact path="/">
                <Home />
            </Route>
            <Route path="/metadata/add">
                <MetadataAdd />
            </Route>
            <Route path="/metadata/preview/:dataId">
                <MetadataPreview />
            </Route>
            <Route path="/metadata">
                <Metadata />
            </Route>

            <Route path="/publication">
                <Publication />
            </Route>

            <Route path="/keywords/add">
                <KeywordsAdd />
            </Route>
            <Route path="/keywords/edit/:dataId">
                <KeywordsEdit />
            </Route>
            <Route path="/keywords">
                <Keywords />
            </Route>

            <Route path="/users/add">
                <UsersAdd />
            </Route>
            <Route path="/users/edit/:dataId">
                <UsersEdit />
            </Route>
            <Route path="/users">
                <Users />
            </Route>

            <Route path="/activities">
                <Activities />
            </Route>

            {
            /*
            //analytics
            //users
            //logs
            */
            }
            <Route path="/logout">
                <Logout />
            </Route>
        </Switch>
    )
}